import { computed, type Ref, toValue } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { useApi } from "@shopexperts/shared";

export function useExpertConversionStats(expertId: Ref<number | string> | number | string) {
  const api = useApi();
  const id = computed(() => toValue(expertId));

  const query = useQuery({
    queryKey: computed(() => ["admin", "expert", id.value, "conversion-stats"]),
    queryFn: () => api.admin.expert.getConversionStats({
      params: { expertId: id.value },
    }),
    enabled: computed(() => !!id.value),
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });

  return {
    stats: computed(() => query.data.value ?? null),
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
